module.exports = __webpack_public_path__ + "static/book-02@2x-119347e2ef9b05f70a703f8872f98635.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/ebook-design-systems/book-02@2x.png
// module id = 2562
// module chunks = 62778679897657